import { useMemo } from 'react';

import useStore from '@/state';
import getBuildcountenabled from '@/state/selectors/options/get-buildcountenabled';
import getThirdparty from '@/state/selectors/options/get-thirdparty';
import { CookiesService } from '@multitenancy-spa/cookies-service';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const useCanUseSavedBuilds = () => {
	const buildCountEnabled = useStore(getBuildcountenabled);
	const thirdParty = useStore(getThirdparty);

	const canUseSaveBuildApi = useMemo<boolean>(() => {
		const gaActive =
			CookiesService.getCookie('_ga') ??
			EnvVarsService.getVar('VITE_GA_ACTIVE', true);
		if (thirdParty) return gaActive && buildCountEnabled;
		return Boolean(gaActive);
	}, [buildCountEnabled, thirdParty]);

	return canUseSaveBuildApi;
};

export default useCanUseSavedBuilds;
